export default __webpack_public_path__ + "static/media/placeholder_store03-nl-mobile.986052a3.png";